













import { Component, Vue, Prop } from 'vue-property-decorator'
import { ReadyPlayer } from '@/class/room'

@Component
export default class PlayerGallarySelect extends Vue {
  @Prop() roomId!: string;
  @Prop() playerId!: string;
  @Prop() readyPlayers!: ReadyPlayer[];

  toPlayerGallary (playerId: string) {
    this.$router.replace({ name: 'playerGallary', params: { roomId: this.roomId, playerId } })
  }

  toGallary () {
    this.$router.replace({ name: 'gallary', params: { roomId: this.roomId } })
  }
}
